// src/context/SavedPostsContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const SavedPostsContext = createContext();

export function SavedPostsProvider({ children }) {
  const userRaw = localStorage.getItem('barterfi_user');
  const user = userRaw ? JSON.parse(userRaw) : null;
  const currentUser = user?.username;

  const [savedPostIds, setSavedPostIds] = useState([]); // ✅ store only post IDs
  const [hasLoaded, setHasLoaded] = useState(false);

  // Initial load of saved IDs (from user object or localStorage)
  useEffect(() => {
    if (!currentUser) {
      console.warn('⛔ No user found in localStorage');
      return;
    }

    // Optionally: fetch saved IDs from backend if stored there
    const loadIdsFromStorage = () => {
      const raw = localStorage.getItem(`savedPostIds-${currentUser}`);
      try {
        const ids = raw ? JSON.parse(raw) : [];
        setSavedPostIds(ids);
        setHasLoaded(true);
      } catch (err) {
        console.error('❌ Failed to parse saved IDs from localStorage:', err);
        setSavedPostIds([]);
        setHasLoaded(true);
      }
    };

    loadIdsFromStorage();
  }, [currentUser]);

  // Save/unsave toggle
  const isSaved = (postId) => savedPostIds.includes(postId);

  const toggleSavePost = (postId, isNowSaved) => {
    const updated = isNowSaved
      ? [...savedPostIds, postId]
      : savedPostIds.filter((id) => id !== postId);

    setSavedPostIds(updated);
    localStorage.setItem(`savedPostIds-${currentUser}`, JSON.stringify(updated));
  };

  const clearSavedPostsState = () => {
    console.log('🧹 Clearing saved post state');
    setSavedPostIds([]);
    setHasLoaded(false);
  };

  return (
    <SavedPostsContext.Provider
      value={{
        savedPostIds,
        isSaved,
        toggleSavePost,
        hasLoaded,
        setHasLoaded,
        clearSavedPostsState
      }}
    >
      {children}
    </SavedPostsContext.Provider>
  );
}

export function useSavedPosts() {
  return useContext(SavedPostsContext);
}
